// extracted by mini-css-extract-plugin
export var activityContainer = "_ne-0";
export var typingIndicatorContainer = "_ne-1";
export var typingIndicatorDot = "_ne-2";
export var wave = "_ne-3";